import React, { Component, ReactChild } from "react";
import { isObject } from "util";
import "./LoggedOutForm.scss";
import logo from "./QUIQspread.svg";

export interface LoggedOutFormProps {
  children: ReactChild | NamedChildren;
}

interface NamedChildren {
  header: ReactChild;
  content: ReactChild;
  prompt: ReactChild;
  footer: ReactChild;
}

class LoggedOutView extends Component {
  public render() {
    const { children } = this.props;

    if (hasNamedChildren(children)) {
      const { header, content, prompt, footer } = children;

      return (
        <div className="LoggedOutForm">
          <div className="LoggedOutForm__header">
            <img src={logo} className="LoggedOutForm__logo" />
            QUIQSpread<sup className="LoggedOutForm__logo-sup">TM</sup>
          </div>
          <div className="LoggedOutForm__body">
            <div className="LoggedOutForm__content">
              <div className="LoggedOutForm__fields">
                <div className="LoggedOutForm__welcome">
                  {header ? header : null}
                </div>
                <div className="LoggedOutForm__prompt">
                  {prompt ? prompt : null}
                </div>
                {content ? content : null}
              </div>
              <div className="LoggedOutForm__instructions">
                {footer ? footer : null}
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      throw new Error("Children are mandatory in LoggedOutView");
    }
  }
}

const hasNamedChildren = (children: any): children is NamedChildren =>
  isObject(children);

export default LoggedOutView;



// WEBPACK FOOTER //
// ./src/login/LoggedOutView.tsx